import { AxiosResponseHeaders } from 'axios';
import { StandingOrdersResponseDTO } from '../entities';

const standingOrderDetailsDTOToStandingOrderDetailsAdapter = (
  data: StandingOrdersResponseDTO,
  headers?: AxiosResponseHeaders,
) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { standingOrderDetailsDTOToStandingOrderDetailsAdapter };
